import productDisplayLandscapeImg from "../../../assets/img/product-gg-display-landscape.png"
import productDisplayLandscapeImgWebp from "../../../assets/img/product-gg-display-landscape.webp"

const SomethingCalled = () => (
    <section id="benefits">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center py-4 gg-bg-solid-green-light">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius">
                    <div className="row justify-content-center align-items-center text-white mb-4">
                        <div className="col-md-10 text-center">
                            <h1>That’s when he told me about something called Glucogen<sup>17</sup>.</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-items-center text-center">
                            <picture>
                                <source srcSet={productDisplayLandscapeImgWebp} type="image/webp" />
                            <img className="img-fluid gg-border-radius" src={productDisplayLandscapeImg} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                            <p>Not a drug. Not a supplement cocktail with ten thousand ingredients I couldn’t pronounce.</p>
                            <p>Glucogen17 was a different formula that came out of years of independent research, built around a simple but overlooked idea:</p>
                            <p className="fw-bold">If you stabilise blood sugar at the source - your glucose metabolism - everything else follows.</p>
                            <p>
                                Each capsule is precision-formulated with natural compounds shown to support blood sugar regulation, cell repair, and metabolic function.<br />
                                It wasn’t made for mass-market shelves. It wasn’t made for hype.
                            </p>
                            <p>
                                It was made for people like me. People who were tired of managing type 2 diabetes like a full-time job,<br />
                                and <b>ready to live like a human being again</b>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default SomethingCalled;